export enum FilterType {
	ASSIGNED_TO_LOCATION = "Assigned To Location",
	PERSON = "Person",
	ACCOUNT = "Account",
	DRAFT_ACCOUNT = "Accounts",
	DRAFT_DESIGNER = "Designer",
	DESIGNER = "Designer",
	BRAND = "Brand",
	ORDER_STATUS = "Order Status",
	ORDER_TYPE = "Order Type",
	SORTED_BY = "SORTED_BY",
	// Custom Quote specific filters (added for CustomQuote filtering feature)
	QUOTE_DESIGNER = "Designer #",
	QUOTE_PRODUCT_LINE = "Product Line",
	QUOTE_STATUS = "Status",
	QUOTED_BY = "Quoted By",
	// Lead specific filters
	LEAD_STATUS = "Lead Status",
	// Marketing Materials and Sample filters
	CHANNEL = "Channel",
	BRAND_AND_PRODUCT_LINE = "Brand & Product Line",
	CATEGORY = "Category",
	TYPE = "Type",
	AVAILABILITY = "Availability"
}
